import React from 'react';
import config from '../internetConfig';
import __ from '../internetLanguage';
import searchStates from '../../searchStates';

function AZStrip() {
	const url = config.isEnglish ? 'https://www.cdc.gov/health-topics.html' : 'https://www.cdc.gov/spanish/az/temas-salud.html';
	return (
		<div className="mb-5 cdc-az-list--tp5">
			<div className="az-strip">
				{'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map((letter, l) => (
					<a
						key={l}
						className="card w-3 h-3 activeLetter az-strip__item"
						href={`${url}#${letter}`}
					>
						<div className="card-body">{letter}</div>
					</a>
				))}
				<a className="card w-3 h-3 activeLetter az-strip__item" href="https://www.cdc.gov/health-topics.html#0">
					<div className="card-body">#</div>
				</a>
			</div>
		</div>
	);
}

export default function NoResults({ searchState }) {
	switch (searchState) {
		case searchStates.READY:
			return (
				<div className="no-results">
					<p className='no-results__message'>{__('noSearchMessage')}</p>
					<AZStrip />
				</div>
			);
		case searchStates.SEARCHING:
			return (
				<div className="no-results">
					<p className="text-center">{__.ucFirst('searching')}...</p>
				</div>
			);
		case searchStates.DONE:
			return (
				<div className="no-results">
					{!config.isEnglish ? (
						<p>{__.ucFirst('zeroResults')}</p>
					) : (
						<>
							<h4 className="no-results__sub-header">Having trouble finding what you want?</h4>
							<ul className='no-results__tips'>
								<li>Make sure all words are spelled correctly</li>
								<li>Try different keywords</li>
								<li>Use a more general search term</li>
							</ul>
							<h4 className="az-strip__header">CDC A-Z Index</h4>
							<p>Browse our A-Z Index to find what you are looking for</p>
							<AZStrip />
						</>
					)}
				</div>
			);
		case searchStates.ERROR:
			return (
				<div className="no-results">
					<p dangerouslySetInnerHTML={{ __html: __('apierror') }}></p>
				</div>
			);
		default:
			return null;
	}
}
